export default __webpack_public_path__ + "static/media/search.79b05a63.svg";